module.exports = __webpack_public_path__ + "static/pike-297f7450a157a27af15bd58d6738d61e.jpg";